var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"default-avatar"},[_c('img',{staticClass:"rounded-circle",staticStyle:{"object-fit":"contain"},attrs:{"src":_vm.currentAvatar,"alt":"custom avatar"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }